module.exports = __webpack_public_path__ + "img/18.8efbb135.jpg";